// FIXME: fix types
const sanitizeStartingRank = async (players, player) => {
    if (player.startingRank) {
        const duplicates = players.filter((p) => p.startingRank === player.startingRank);
        if (duplicates.length <= 1) {
            // startingRank is set and not duplicated (good)
            return;
        }
        // duplicated
        if (player.games.length > 0) {
            // but played, no need to fix
            return;
        }
    }
    // missing or duplicated startingRank and not yet played any game, calculate next starting rank
    const startingRanks = players.map((p) => p.startingRank).filter((st) => !!st);
    return Array.from({ length: startingRanks.length + 1 }, (_, i) => i + 1).find((r) => !startingRanks.includes(r));
};
export const sanitizePlayers = async (firestore, tournament, players) => {
    for (let i = 0; i < players.length; i++) {
        const player = players[i];
        const startingRank = await sanitizeStartingRank(players, player);
        if (!startingRank) {
            continue;
        }
        player.startingRank = startingRank;
        if (!firestore || !tournament) {
            continue;
        }
        await firestore
            .collection("tournaments")
            .doc(tournament.id)
            .collection("players")
            .doc(player.username)
            .update({
            startingRank,
        });
    }
};
